export function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
};

// Returns a patient's age, preferring a computed value from dateOfBirth
// and falling back to a directly-entered age (used when DOB is unknown).
export function getPatientAge(patient) {
    if (!patient) return "NA";

    if (patient.dateOfBirth) {
        const dob = new Date(patient.dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }
        return age;
    }

    if (patient.age || patient.age === 0) return patient.age;

    return "NA";
};


